import { useMemo } from 'react';

interface ServiceTagsProps {
  items: Array<{ text: string; iconUrl: any; hide?: boolean }>;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  width?: any;
  isForAccList?: boolean;
  isDetail?: boolean;
  isHompage?: boolean;
}

const ServiceTags = ({
  items,
  className,
  size = 'large',
  width = 80,
  isForAccList = false,
  isDetail = false,
  isHompage = false,
}: ServiceTagsProps) => {
  const _size = {
    small: {
      parentClassName: 'pl-1 pr-2 py-1 rounded-tr-3xl lg:pl-3.5 lg:pr-5 lg:py-1.5',
      fontSize: 'text-[8px] font-medium leading-4 lg:text-[10px] lg:font-semibold',
      iconSize: 'w-2 h-2 lg:w-3 lg:h-3',
      gap: 'gap-0.5 lg:gap-1',
    },
    medium: {
      parentClassName: 'pl-1 pr-2 py-1 rounded-tr-3xl lg:pl-3 lg:pr-4 lg:py-1',
      fontSize: 'text-[8px] font-medium leading-4 lg:text-[11px] lg:font-semibold',
      iconSize: 'w-2 h-2 lg:w-3 lg:h-3',
      gap: 'gap-0.5 lg:gap-1',
    },
    large: {
      parentClassName: 'pl-4 pr-5 py-2 rounded-br-3xl',
      fontSize: 'text-[10px] leading-4 font-semibold lg:text-xs',
      iconSize: 'w-4 h-4',
      gap: 'gap-1',
    },
  };

  const visibleItems = useMemo(() => items.filter((tag) => !tag.hide), [items]);

  // Define if service tags should be hidden
  const isHidden = useMemo(() => {
    return !items?.length || items?.every((tag) => tag.hide);
  }, [items]);
  const widtWord = visibleItems.length > 1 ? 120 : 145;
  return (
    <div
      aria-label="Service Tags"
      className={`w-fit max-w-full bg-service-tags  bg-orange-500 bg-center bg-no-repeat bg-cover  ${isHidden ? 'hidden lg:hidden' : 'block'} ${_size[size]?.parentClassName} ${className}`}
    >
      <p className={`text-[#FFFFFF] ${_size[size]?.fontSize}`}>
        <span className={`flex overflow-x-scroll hideScrollBar ${_size[size]?.gap}`}>
          {visibleItems.map((item, index) => (
            <span
              key={index}
              style={{ maxWidth: width }}
              className={`flex ${_size[size]?.gap} items-center`}
            >
              <img
                className={_size[size]?.iconSize}
                src={item.iconUrl?.src || item.iconUrl}
                alt="tag icon"
              />
              {isForAccList ? (
                <span
                  className={`${
                    visibleItems.length === 1
                      ? ''
                      : index === visibleItems.length - 1
                        ? 'truncate'
                        : ''
                  } ${isHompage ? 'lg:text-[8px] xl:text-[11px]' : ''}`}
                  style={{ maxWidth: widtWord }}
                  title={item.text}
                >
                  {item.text}
                </span>
              ) : (
                <span
                  // className={`line-clamp-1 `}
                  className={'truncate'}
                  title={item.text}
                >
                  {item.text}
                </span>
              )}

              {index + 1 < visibleItems.length ? (
                <span className="text-[#FFFFFF] px-[2px]">&#x2022;</span>
              ) : null}
            </span>
          ))}
        </span>
      </p>
    </div>
  );
};

export default ServiceTags;
